// Bundle theme module
import NSTheme from './NSTheme';
import LazyLoad from './lib/lazyload';
import Swiper from './lib/swiper';
import Helper from './Classes/Helper';
import Menu from './Classes/Menu';
import ScrollSpy from './Classes/ScrollSpy';
import Filtering from './Classes/Filtering';
import Offerings from './Classes/Offerings';
import Searchform from './Classes/Searchform';
import PostLoader from './Classes/PostLoader';
import ProjectLoader from './Classes/ProjectLoader';
import TeamLoader from './Classes/TeamLoader';
import FocusHandler from './Classes/FocusHandler';
import Dropdown from './Classes/Dropdown';
import Animation from './Classes/Animation';
import Survey from './Classes/Survey';
import Konami from './Classes/Konami';

// import babelpolyfill from 'babel-polyfill';

import Accordion from './Classes/Accordion';

module.exports = NSTheme;

(function() {
  document.addEventListener('DOMContentLoaded', function() {
		new LazyLoad();

		new Survey({
			formID: 'survey'
		});

		const sliderImages = Array.prototype.slice.call(document.querySelectorAll('.swiper-slide img'));
		sliderImages.forEach(image => {
			const imgSrc = image.dataset.src;
			image.src = imgSrc;
			Helper.addClass(image, 'loaded');
		});

		const wave = new Animation({
			svgSelector: document.getElementById('wave'),
			final: '#one',
			gerade: '#gerade',
			umgekehrt: '#two'
		});

		const zigzag = new Animation({
			svgSelector: document.getElementById('zigzag'),
			final: '#one',
			gerade: '#gerade',
			umgekehrt: '#two'
		});

	// 	var svg = document.getElementById("svgone");
  // var s = Snap(svg);
  // var final = Snap.select('#one');
  // var gerade = Snap.select('#gerade');
  // var umgekehrt = Snap.select('#two');
  // var finalCupPoints = final.node.getAttribute('d');
  // var geradePoints = gerade.node.getAttribute('d');
  // var thirdPoints = umgekehrt.node.getAttribute('d');

  // var anim1 = function(){
  //   gerade.animate({ d: finalCupPoints }, 1000, mina.linear, anim2);
  // }

  // var anim2 = function(){
  //   gerade.animate({ d: geradePoints }, 1000, mina.backout, function(){
  //     setTimeout(function(){ anim3() }, 100);
  //   });
  // }

  // var anim3 = function(){
  //   gerade.animate({ d: thirdPoints }, 1000, mina.linear, anim4);
  // }

  // var anim4 = function(){
  //   gerade.animate({ d: geradePoints }, 1000, mina.backout, function(){
  //     setTimeout(function(){ anim5() }, 100);
  //   });
  // }

  // var anim5 = function(){
  //   gerade.animate({ d: finalCupPoints }, 1000, mina.linear);
  // }

	// anim1();

    const focushandler = new FocusHandler();
    const searchform = new Searchform();
    const navigation = new Menu();
    const jobsAccordion = new Accordion();
    const gallerySwiper = new Swiper('.swiper-container', {
      loop: true,
      slidesPerView: 1.5,
      centeredSlides: true,
      autoHeight: true,
			breakpointsInverse: true,
			spaceBetween: 25,
			breakpoints: {
				480: {
					spaceBetween: 50,
				},
				1250: {
					spaceBetween: 75,
				}
			},
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboard: {
        enabled: true,
      },
    });

    const konami = new Konami();


    const headerSpy = new ScrollSpy({
			header: '.header'
		});

		const teamFilter = new Filtering({
			filterBoxContainerSelector: '.employees',
			filterBoxSelector: '.employees__employee',
			loadMoreButtonSelector: '.js-load-more-employees',
			filterButtonSelector: '.filter__button',
			filterButtonDataAttribute: 'employer-target',
			filterBoxDataAttribute: 'target'
		});

		const posts = new PostLoader({
			postLoaderSelector: '.js-load-more-posts',
			postContainerSelector: '.story-list',
			filterButtonSelector: '.filter__button',
			filterButtonDataAttribute: 'post-target',
			postBoxSelector: '.post-list__post',
		});

		const cases = new PostLoader({
			postLoaderSelector: '.js-load-more-posts',
			postContainerSelector: '.cases-list',
			filterButtonSelector: '.filter__button',
			filterButtonDataAttribute: 'post-target',
			postBoxSelector: '.post-list__post',
			type: 'cases'
		});

		const offerings = new Offerings({
			offeringsContainer: '.offerings',
			filterButtonSelector: '.offerings__filter',
			filterButtonDataAttribute: 'show-graphic',
			graphicsContainerSelector: '#Leistungsgrafik'
		});

		const teamCase = new TeamLoader({
			type: 'cases',
			buttonSelector: '.js-open-team[data-case-id]',
			buttonDataAttribute: 'case-id',
		});

		const teamStory = new TeamLoader({
			type: 'post',
			buttonSelector: '.js-open-team[data-post-id]',
			buttonDataAttribute: 'post-id',
		});

		const offeringsFilter = new Dropdown({
			submenuTogglerSelector: '.offerings__dropdown-toggler',
		});

		const filterDropdown = new Dropdown({
			submenuTogglerSelector: '.js-toggle-filter',
		});

		const projectPopup = new ProjectLoader({
			buttonSelector: '.js-open-projects',
			buttonDataAttribute: 'employee-id',
		});

  });
})();
